import axios from "axios";

 const deleteDataByID = (params: string): Promise<any> => {
  return axios.delete(`forms/${params}`);
};

export default deleteDataByID
